module.exports = __webpack_public_path__ + "static/media/20180721-kuppruefung-31.1fd4b8d8.jpg";